export const BASE_URL = process.env.REACT_APP_TICKET_URL;
